import Http from "./HttpService";

import { DEFAULT_LIMIT, DEFAULT_OFFSET } from "../constants/pagination";

class CoursesService extends Http {
  BASE_URL = "/admins/course-categories";
  BASE_URL_COURSES = "/admins/courses";

  getList(id, pagination = {}) {
    const { limit = DEFAULT_LIMIT, offset = DEFAULT_OFFSET } = pagination;

    return this.get(`${this.BASE_URL}/${id}/courses`, {
      params: {
        limit,
        offset,
      },
    });
  }

  getPaginatedCourseList(pagination = {}) {
    const { limit = DEFAULT_LIMIT, offset = DEFAULT_OFFSET } = pagination;

    return this.get(`${this.BASE_URL_COURSES}`, {
      params: {
        limit,
        offset,
      },
    });
  }

  create(id, model) {
    return this.post(`${this.BASE_URL}/${id}/courses`, model);
  }

  async getOne(id) {
    const { data } = await this.get(`${this.BASE_URL_COURSES}/${id}`);
    if (!data.video) {
      return { data };
    }
    const initialFile = data.video;
    initialFile.preview = data.video.videoPreview || null;
    initialFile.size = null;

    if (initialFile?.thumbnailImage) {
      initialFile.thumbnailImage.preview = initialFile.thumbnailImage.link;
      initialFile.thumbnailImage.size = null;
    }

    let courseThumbnailImageInitialFile = null;
    let student0ImageInitialFile = null;
    let student1ImageInitialFile = null;
    let student2ImageInitialFile = null;
    
    if (data.courseThumbnailImage) {
      courseThumbnailImageInitialFile = data.courseThumbnailImage;
    courseThumbnailImageInitialFile.preview = data.courseThumbnailImage.resizedImages
      ? data.courseThumbnailImage.resizedImages[Object.keys(data.courseThumbnailImage.resizedImages)[0]]
      : data.courseThumbnailImage.link;
      courseThumbnailImageInitialFile.size = null;
    }

    if (data.studentsSays && data.studentsSays.length > 0) {
      const studentImageInitialFiles = {};

      for (let i = 0; i < data.studentsSays.length; i++) {

        if (data.studentsSays[i]?.courseStudentSayImage) {
          const imageData = data.studentsSays[i].courseStudentSayImage;
          // Create dynamic variable name: student0ImageInitialFile, student1ImageInitialFile, etc.
          const variableName = `student${i}ImageInitialFile`;
          studentImageInitialFiles[variableName] = {
            ...imageData,
            preview: imageData.resizedImages
              ? imageData.resizedImages[Object.keys(imageData.resizedImages)[0]]
              : imageData.link,
            size: null
          };
        }
      }
      // Extract the individual variables
      student0ImageInitialFile = studentImageInitialFiles.student0ImageInitialFile || null;
      student1ImageInitialFile = studentImageInitialFiles.student1ImageInitialFile || null;
      student2ImageInitialFile = studentImageInitialFiles.student2ImageInitialFile || null;
    }
    
    

    return { data: { ...data, initialFile, courseThumbnailImageInitialFile, student0ImageInitialFile, student1ImageInitialFile, student2ImageInitialFile } };
  }

  update(id, model) {
    return this.put(`${this.BASE_URL_COURSES}/${id}`, model);
  }

  changeStatus(id) {
    return this.patch(`${this.BASE_URL_COURSES}/${id}/status`);
  }

  remove(id) {
    return this.delete(`${this.BASE_URL_COURSES}/${id}`);
  }

  addVideo(id, model) {
    return this.post(`${this.BASE_URL_COURSES}/${id}/video`, model);
  }

  addCourseThumbnailImage(id, model) {
    return this.post(`${this.BASE_URL_COURSES}/${id}/course-thumbnail-image`, model);
  }

  addCourseStudentSaysImages(id, model) {
    return this.post(`${this.BASE_URL_COURSES}/${id}/course-student-says/files`, model);
  }

  changeVideoThumbnail(courseId, videoThumbnailId) {
    return this.put(
      `${this.BASE_URL_COURSES}/${courseId}/video/thumbnail`,
      {
        videoThumbnailId,
      },
      {
        disableToast: true,
      }
    );
  }

  updateVideoTags(courseId, tags) {
    return this.put(
      `${this.BASE_URL_COURSES}/${courseId}/video/tags`,
      {
        tags,
      },
      {
        disableToast: true,
      }
    );
  }

  setRecommendations(courseId, model) {
    return this.put(`${this.BASE_URL_COURSES}/${courseId}/recommendations`, model)
  }

  getAllCoursesList(pagination = {}) {
    const { limit = DEFAULT_LIMIT, offset = DEFAULT_OFFSET } = pagination;

    return this.get(`/courses`, {
      params: {
        limit,
        offset,
      },
    });
  }

  getAllCoursesListWithLessonSummaryInfo(pagination = {}, filters = {}) {
    const { limit = DEFAULT_LIMIT, offset = DEFAULT_OFFSET } = pagination;

    return this.get(`/courses/list-with-lesson-summary-info`, {
      params: {
        limit,
        offset,
        ...filters,
      },
    });
  }
}

export default new CoursesService();
